export const Empty = ({ icon, title, subtitle, testid = "empty-state" }) => (
  <div
    data-testid={testid}
    className="flex-1 flex flex-col items-center justify-center text-center py-20 px-8 min-h-[45vh]"
  >
    <div className="text-onsurface3 mb-4">{icon}</div>
    <p className="text-lg font-black text-onsurface">{title}</p>
    <p className="mt-1 text-[13px] text-onsurface3">{subtitle}</p>
  </div>
);

export const GenderToggle = ({ value, onChange }) => (
  <div className="flex gap-2 bg-[#1c1c1e] p-1 rounded-full">
    {[
      ["Men", "Uomo"],
      ["Women", "Donna"],
    ].map(([val, label]) => (
      <button
        key={val}
        data-testid={`gender-toggle-${val.toLowerCase()}`}
        onClick={() => onChange(val)}
        className={`flex-1 py-2.5 rounded-full font-bold text-base transition-colors ${
          value === val ? "bg-brand text-onbrand" : "text-white"
        }`}
      >
        {label}
      </button>
    ))}
  </div>
);
